module.exports = __webpack_public_path__ + "static/media/pic4@2x.c3a6922e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/pic4@2x.png
// module id = 1416
// module chunks = 0